import React, {  useState, Fragment } from 'react'
import styles from './NavBar.module.css';
import { NavLink } from 'react-router-dom';
import Hamburger from '../Hamburger/Hamburger';
import TagManager from 'react-gtm-module';
import APPCONST from '../../Constants/constants';
import 'font-awesome/css/font-awesome.min.css';

const NavBar = (props) => {
	// let coming_soon = (props.coming_soon === undefined) ? true : props.coming_soon;
	const tagManagerArgs = {
		gtmId: APPCONST.googleTagManagerCode
	}
	
	TagManager.initialize(tagManagerArgs);

	const [mobileMenuOpen, toggleMobileMenu] = useState(false);

	/*const contestOver = () => {
		let currentdt = new Date();
		//let contestenddt = new Date('September 30, 2020 24:00')
		return (APPCONST.contest_end_date < currentdt);
	}*/

	return (
		<div className={[mobileMenuOpen === true ? styles.mobile_open : undefined, styles.container].join(' ')}>
			
				<Fragment>
					<nav className={styles.pageWrap}>
						<div className={styles.hamburger_container}>
							<div className={styles.hamburger}>
								<Hamburger open={mobileMenuOpen} onClick={() => toggleMobileMenu(mobileMenuOpen === false)} />
							</div>
						</div>
						<div className={styles.leftContainer} onClick={() => toggleMobileMenu(false)}>
							<NavLink 
								data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Home||/home"
								to="/home" className={styles.item} activeClassName={styles.itemSelected}
							>
								Home
							</NavLink>
							<NavLink 
								data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Pre-seed herbicide benefits||/preseedherbicide"
								to="/preseedherbicide" className={styles.item} activeClassName={styles.itemSelected}
							>
								Pre-seed Herbicide Benefits 
							</NavLink>
							<NavLink 
								data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Certitude|/certitude"
								to="/certitude" className={styles.item} activeClassName={styles.itemSelected}
							>
								Certitude
							</NavLink>
							<NavLink 
								data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Smoulder|/smoulder"
								to="/smoulder" className={styles.item} activeClassName={styles.itemSelected}
							>
								Smoulder
							</NavLink>
							<NavLink 
								data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "Voraxor"
								to="/voraxor" className={styles.item} activeClassName={styles.itemSelected}
							>
								Voraxor
							</NavLink>
							{/* <NavLink 
								data_tealium_category="link"
								data_tealium_action="click"
								data_tealium_type="navigation"
								data_tealium_value= "EnterContest"
								to="/entercontest" className={styles.item} activeClassName={styles.itemSelected}
							>
								Contest
							</NavLink> */}
					
						</div>
					</nav>
				</Fragment>
		
		
		
		</div>
	)
}

export default NavBar;